import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as compareProducts from './state/compare-products.reducer';
import { CompareProductsFacade } from './state/compare-products.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(compareProducts.COMPARE_PRODUCTS_FEATURE_KEY, compareProducts.compareProductsReducer),
  ],
  providers: [CompareProductsFacade],
})
export class CompareProducts {}
